(() => {
  class GloboFormController {
    constructor() {
      this.productTitle = document.querySelector("[data-title]");
      this.productInputWrapper = document.querySelector(".product-item");
      this.productInput = document.querySelector(".product-item .globo-form-input input");
      this.fieldInputs = document.querySelectorAll(
        ".globo-form-input input, .globo-form-input textarea, .globo-form-input select"
      );
      this.dropZone = document.querySelectorAll(".globo-form-input .gfb__dropzone");
    }

    setProductValue(value) {
      if (this.productInput) {
        this.productInput.value = value;
      }
    }

    getProductTitleValue() {
      return this.productTitle ? this.productTitle.getAttribute("data-title") : null;
    }

    hideProductInput() {
      if (this.productInputWrapper) {
        this.productInputWrapper.style.display = "none";
      }
    }

    setInputBackgroundColor(...classes) {
      this.fieldInputs.forEach((input) => {
        input.classList.add(...classes);
      });
    }

    setOptionTextColor(...classes) {
      this.fieldInputs.forEach((input) => {
        if (input.tagName.toLowerCase() === "select") {
          input.querySelectorAll("option").forEach((option) => {
            option.classList.add(...classes);
          });
        }
      });
    }

    setDropzoneBackgroundColor(...classes) {
      this.dropZone.forEach((dropzone) => {
        dropzone.classList.add(...classes);
      });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      const controller = new GloboFormController();
      const title = controller.getProductTitleValue();

      controller.hideProductInput();
      controller.setProductValue(title);
      controller.setInputBackgroundColor(
        "!bg-white/10",
        "!border-[1px]",
        "!border-white",
        "!border-solid",
        "!text-white",
        "!rounded-[0]"
      );
      controller.setDropzoneBackgroundColor("!bg-white/10");
      controller.setOptionTextColor("text-black");
    }, 1000);
  });

  class GloboFormInputController {
    constructor() {
      this.fieldInputs = document.querySelectorAll(
        ".globo-form-input input, .globo-form-input textarea, .globo-form-input select"
      );
    }

    setInputBackgroundColor(...classes) {
      this.fieldInputs.forEach((input) => {
        input.classList.add(...classes);
      });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      const controller = new GloboFormInputController();
      controller.setInputBackgroundColor(
        "!bg-white/10",
        "!border-[1px]",
        "!border-white",
        "!border-solid",
        "!text-white",
        "!rounded-[0]"
      );
      console.log("loaded");
    }, 2000);
  });
})();